import lodash from 'lodash'
import { createLoading } from "../../../../utils/loading";
import { createPage } from "../../../../utils/page";
import { conditionFormChecker, putField } from "../../../../utils/form";
import {
    createFieldCheckbox,
    createFieldInput
} from "../../../../components/input/template-builder/template-builder.logic";
// import i18n from "../../../../i18n";
import { clearRulesStartsWith } from "../../../../utils/validate";
import { Button, Form } from "ant-design-vue";
import { CIcon } from "../../../account/verify-identity-file/attach-identity/attach-identity-id-card.logic";

export const { isLoading, setIsLoading } = createLoading()

export const initData = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.page = createPage({ data: items });
};

export const createField = ({ props, data, key, record, index, itemsKey }) => {
    const { viewOnly, canDelete, surveyQuestionKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";

    const surveyQuestion = lodash.get(modelRef, surveyQuestionKey);
    const modelQuestionChoices = lodash.get(modelRef, itemsKey);

    return putField({
        data,
        fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 1 }),
            },
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model }  }),
                key: `${prefix}isCheck`,
                colProp: () => ({ xs: 24, md: 2 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                inputProp: ({ field }) => {
                    let borderRadiusCheckbox = surveyQuestion?.refChoiceType?.key == "checkbox" ? 0 : 45
                    let otherCheckInGroup = false;

                    if(surveyQuestion?.refChoiceType?.key == "radio") {
                        otherCheckInGroup = modelQuestionChoices.find(
                            (d) => d.id !== model.id && d.isCheck
                        );
                    }
                    return lodash.merge(
                        {
                            checked: model?.isCheck,
                            "onUpdate:checked": (checked) => {
                                model.isSave = true;
                                model.isCheck = checked;
                                surveyQuestion.isSave = true

                            },
                            disabled: otherCheckInGroup ? true : viewOnly,
                            text: () => "",
                            style: { borderRadius: `${50 + borderRadiusCheckbox}%` },
                            class:  "hidden-checkbox-only",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}value`,
                colProp: () => ({ xs: 24, md: 19 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                label: () => "",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.value,
                            "onUpdate:value": (value) => (model.value = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            {
                visible: () => canDelete,
                // visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}deleteChoiceButton`,
                colProp: () => ({ xs: 24, md: 2 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                label: () => "",
                formItemRender: ({ field }) => {
                    const label = field?.label?.();
                    const formItemProp = field?.formItemProp?.({ field });
                    return (
                        <Form.Item label={label} {...formItemProp}>
                            <Button
                                class="btn-danger m-2"
                                size="small"
                                onClick={() => onClickDelete({record, index, props, data})}
                            >
                                <CIcon file="delete.svg"></CIcon>
                            </Button>
                        </Form.Item>
                    );
                }
            },
        ]
    })
}

export const onClickDelete = ({ record, index, props, data }) => {
    if (record.id) {
        record.isDelete = true;
    } else {
        Promise.resolve()
            .then(() => clearRulesStartsWith({ useForm: data.useForm, key: `${props.itemsKey}.` }))
            .then(() => lodash.get(data.useForm.modelRef, props.itemsKey).splice(index, 1));
    }
};